import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  BillingListResponse,
  Licence,
  SubscriptionsService,
  SubscriptionStatus
} from '../../../../services/subscriptions'
import { BehaviorSubject, EMPTY, Observable, of, Subject, take } from 'rxjs'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { eps } from '../../../../services/url.service'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { SubscriptionInvoiceComponent } from '../../subscribers/subscription-invoice/subscription-invoice.component'
import { Business } from '../../../../store/business/business.state'
import { UtilsService } from '../../../../services/utils.service'
import { RazorpayService } from '../../../../services/razorpay.service'
import { PaymentsService } from '../../../../services/payments.service'
import { ToastrService } from 'ngx-toastr'
import { AuthState } from '../../../../store/auth/auth.state'
import { LoaderComponent } from '../../../../shared/components/loader/loader.component'
import { PAGE_LIMIT } from '../../../../store/state.constants'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { SharedModule } from '../../../../shared/shared.module'

@Component({
  selector: 'app-billing',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoaderComponent,
    PaginationComponent,
    FormsModule,
    SharedModule
  ],
  templateUrl: './billing.component.html',
  styleUrl: './billing.component.scss'
})
export class BillingComponent implements OnInit {
  store = inject(Store)
  modalService = inject(NgbModal)
  route = inject(ActivatedRoute)
  router = inject(Router)
  eps = eps
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  private modalRef!: NgbModalRef
  private razorpayService = inject(RazorpayService)
  private paymentsService = inject(PaymentsService)
  private toastr = inject(ToastrService)

  subscriptionStatus = SubscriptionStatus
  subscriptionStatusValues = Object.values(SubscriptionStatus)
  subscriptionDisplayId = ''
  subscriptionId = ''
  subscriptionsService = inject(SubscriptionsService)
  billing$ = new BehaviorSubject<BillingListResponse | null>(null)
  // billing$: Observable<Licence[]> = of([])

  totalLicences = 0
  mergedLicences: Licence[] = []
  SubscriptionInvoiceComponent = SubscriptionInvoiceComponent
  planCurrencySymbol: string = ''
  adminBusiness!: Business
  user: AuthState['user'] | null = null
  @ViewChild('editBusinessModal')
  editBusinessModal!: TemplateRef<any>
  businessForm!: FormGroup
  selectedBusiness!: Business
  currentInvoiceModal?: NgbModalRef
  isUpdatingBusiness = false
  isProcessingPayment = false
  businessId!: string

  private loadTrigger$ = new Subject<void>()
  isLoading = true
  totalCount = 0
  currentPage = 1
  pageLimit = PAGE_LIMIT
  pageLastRecord = 0
  search = ''
  filter = ''
  constructor(
    private utilsService: UtilsService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initBusinessForm()
    // this.subscriptionsService
    //   .getBillings({})
    //   .pipe(take(1))
    //   .subscribe(res => {
    //     this.billing$.next(res)

    //     this.adminBusiness = res.adminBusiness
    //     this.isLoading = false
    //   })
    this.load()
  }

  load(): void {
    this.isLoading = true

    const params = {
      page: this.currentPage,
      limit: this.pageLimit,
      search: this.search.trim(),
      filter: this.filter
    }

    this.subscriptionsService
      .getBillings(params)
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.billing$.next(res)

          this.adminBusiness = res.adminBusiness

          // API response:
          // {
          //   data: [...],
          //   total: 100,
          //   page: 1,
          //   limit: 10
          // }

          this.totalCount = res.total ?? 0
          // this.currentPage = res.page ?? 1
          // this.pageLimit = res.limit ?? PAGE_LIMIT

          this.updatePageLastRecord()

          this.isLoading = false
        },

        error: err => {
          console.error('Failed to fetch billing:', err)

          this.isLoading = false
          this.billing$.next(null)
          this.totalCount = 0
          this.pageLastRecord = 0
        }
      })
  }

  openInvoiceModal(
    component: any,
    licence: any,
    business: Business,
    adminBusiness: Business,
    subscription: any
  ) {
    const modalRef = this.modalService.open(component, {
      size: 'xl',
      centered: true
    })
    // apne actual subscription/invoice data ke hisaab se map karo
    modalRef.componentInstance.invoiceData = licence
    modalRef.componentInstance.businessData = business
    modalRef.componentInstance.adminBusinessData = adminBusiness
    modalRef.componentInstance.subscriptionData = subscription
    // modalRef.componentInstance.invoiceData = {
    //   licence,
    //   business,
    //   adminBusiness
    // }

    modalRef.componentInstance.editBusiness.subscribe(() => {
      this.openEditBusinessModal(business, modalRef.componentInstance)
    })

    modalRef.result.finally(() => {
      this.currentInvoiceModal = undefined
    })
  }

  isAdmin(): boolean {
    return this.utilsService.isAdmin()
  }

  initBusinessForm() {
    this.businessForm = this.fb.group({
      id: [''],
      businessName: ['', Validators.required],
      legalName: [''],
      address: [''],
      // city: [''],
      // cityId: [null],
      // state: [''],
      // stateId: [null],
      // country: [''],
      // countryId: [null],
      // zipCode: [''],
      GST: [''],
      email: ['', [Validators.email]],
      mobile: [''],
      // website: [''],
      PAN: ['']
    })
  }

  openEditBusinessModal(business: Business, invoiceComponent?: any, paymentId?: any) {
    this.selectedBusiness = business
    const city = business.city as any

    this.businessForm.patchValue({
      id: paymentId ?? '',
      businessName: business.businessName ?? '',
      legalName: business.legalName ?? '',
      address: business.address ?? '',

      // city: city?.name ?? '',
      // cityId: business.cityId ?? null,

      // state: city?.state?.name ?? '',
      // stateId: business.city?.state?.id ?? null,

      // country: city?.state?.country?.name ?? '',
      // countryId: business.city?.country_id ?? null,

      // zipCode: business.zipCode ?? '',

      GST: business.GST ?? '',

      email: business.user?.email ?? '',
      mobile: business.user?.mobile ?? '',

      // website: business.website ?? '',
      PAN: business.PAN ?? ''
    })

    const modalRef = this.modalService.open(this.editBusinessModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    })

    modalRef.result
      .then(result => {
        if (result === 'updated' && invoiceComponent) {
          // Invoice component ke businessData ko update karo
          invoiceComponent.businessData = {
            ...business
          }
        }
      })
      .catch(() => {})
  }

  updateBusiness(modal: NgbModalRef) {
    if (this.businessForm.invalid) {
      this.businessForm.markAllAsTouched()
      return
    }

    // if (!this.selectedBusiness?.id) {
    //   return
    // }

    this.isUpdatingBusiness = true

    const formValue = this.businessForm.getRawValue()

    const payload = {
      // id: this.selectedBusiness.id,
      id: formValue.id,
      businessName: formValue.businessName,
      legalName: formValue.legalName,

      address: formValue.address,

      // cityId: formValue.cityId,
      // stateId: formValue.stateId,
      // countryId: formValue.countryId,

      // zipCode: formValue.zipCode,

      GST: formValue.GST,

      // website: formValue.website,
      PAN: formValue.PAN,

      user: {
        email: formValue.email,
        mobile: formValue.mobile
      }
    }

    Object.assign(this.selectedBusiness, {
      businessName: formValue.businessName,
      legalName: formValue.legalName,
      address: formValue.address,
      // cityId: formValue.cityId,
      // stateId: formValue.stateId,
      // countryId: formValue.countryId,
      // zipCode: formValue.zipCode,
      GST: formValue.GST,
      // website: formValue.website,
      PAN: formValue.PAN
    })

    if (this.selectedBusiness.user) {
      this.selectedBusiness.user.email = formValue.email
      this.selectedBusiness.user.mobile = formValue.mobile
    }

    this.isUpdatingBusiness = false

    this.subscriptionsService
      .updateInvoiceBusiness(payload)
      .pipe(take(1))
      .subscribe({
        next: response => {
          this.isUpdatingBusiness = false

          const updatedBusiness = response.data.business

          const updatedUser = response.data.user

          // -----------------------------
          // Update local business object
          // -----------------------------

          Object.assign(this.selectedBusiness, updatedBusiness)

          this.selectedBusiness.user = updatedUser

          // Close edit modal
          modal.close('updated')
        },

        error: error => {
          this.isUpdatingBusiness = false

          console.error('Business update failed:', error)

          // yahan aap apna toast service use kar sakte ho
        }
      })
    modal.close('updated')
  }

  changeAutopayMethod(): void {
    if (this.isProcessingPayment) {
      return
    }

    const billing = this.billing$.value

    const subscription = billing?.data?.find(
      item => item.subscription?.subscriptionStatus === 'active' && !!item.subscription?.belongsTo
    )?.subscription

    if (!subscription) {
      this.toastr.error('Active subscription not found.')
      return
    }

    this.businessId = subscription.belongsTo
    this.isProcessingPayment = true

    this.paymentsService.initiateAutopayMethodChange(this.businessId).subscribe({
      next: response => {
        this.openAutopayChangeCheckout(response)
      },

      error: err => {
        console.error('Failed to initiate autopay method change', err)

        this.isProcessingPayment = false

        this.toastr.error(
          err?.error?.message || 'Unable to change autopay method. Please try again.'
        )
      }
    })
  }

  private openAutopayChangeCheckout(response: any): void {
    // console.log('🔍 Razorpay checkout options:', response)
    this.razorpayService
      .load()
      .then(() => {
        const options = {
          key: response.key,

          subscription_id: response.subscriptionId,

          name: 'AVR HRMS',

          description: 'Change Autopay Payment Method',

          prefill: {
            name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
            email: this.user?.email ?? '',
            contact: this.user?.mobile ?? ''
          },

          notes: {
            purpose: 'CHANGE_AUTOPAY_METHOD',
            businessId: this.businessId,
            internalSubscriptionId: response.internalSubscriptionId
          },

          handler: (razorpayResponse: any) => {
            console.log('Autopay method change response', razorpayResponse)

            this.verifyAutopayMethodChange(razorpayResponse, response.internalSubscriptionId)
          },

          modal: {
            ondismiss: () => {
              this.isProcessingPayment = false

              this.toastr.info('Autopay method change was cancelled.')
            }
          },

          theme: {
            color: '#3399cc'
          }
        }

        const rzp = new window.Razorpay(options)

        rzp.open()
      })
      .catch(error => {
        console.error('Failed to load Razorpay', error)

        this.isProcessingPayment = false

        this.toastr.error('Could not connect to payment gateway.')
      })
  }

  private verifyAutopayMethodChange(razorpayResponse: any, internalSubscriptionId: string): void {
    this.paymentsService
      .verifyAutopayMethodChange({
        internalSubscriptionId,

        razorpayPaymentId: razorpayResponse.razorpay_payment_id,

        razorpaySubscriptionId: razorpayResponse.razorpay_subscription_id,

        razorpaySignature: razorpayResponse.razorpay_signature
      })
      .subscribe({
        next: () => {
          this.isProcessingPayment = false

          this.toastr.success('Autopay payment method changed successfully.')
        },

        error: err => {
          console.error('Autopay method verification failed', err)

          this.isProcessingPayment = false

          this.toastr.error('Payment method verification failed.')
        }
      })
  }

  // getCurrentSubscription(): any {
  //   const billing = this.billing$.value

  //   return (
  //     billing?.data?.find(item => item.subscription?.subscriptionStatus === 'active')
  //       ?.subscription ?? null
  //   )
  // }
  // getCurrentSubscription(): any {
  //   const billing = this.billing$.value

  //   const item = billing?.data?.find(item => item.subscription?.subscriptionStatus === 'active')

  //   if (!item?.subscription) {
  //     return null
  //   }

  //   const payment = item.payments?.find(payment => !!payment.gatewayPaymentId)

  //   return {
  //     ...item.subscription,
  //     gatewayPaymentId: payment?.gatewayPaymentId ?? null
  //   }
  // }

  getCurrentSubscription(): any {
    const billing = this.billing$.value

    const item = billing?.data?.find(item => item.subscription?.subscriptionStatus === 'active')

    if (!item?.subscription) {
      return null
    }

    const payment = item.payments?.find(payment => !!payment.gatewayPaymentId)

    return {
      ...item.subscription,
      gatewayPaymentId: payment?.gatewayPaymentId ?? null
    }
  }

  // activateAutopay(): void {
  //   if (this.isProcessingPayment) {
  //     return
  //   }

  //   this.isProcessingPayment = true

  //   const subscription = this.getCurrentSubscription()

  //   if (!subscription?.id) {
  //     this.isProcessingPayment = false

  //     this.toastr.error('Active subscription not found.')

  //     return
  //   }

  //   this.paymentsService.authenticateMandate(subscription.gatewayPaymentId).subscribe({
  //     next: response => {
  //       this.openMandateCheckout(response)
  //     },

  //     error: (err: any) => {
  //       console.error('Autopay activation failed', err)

  //       this.isProcessingPayment = false

  //       this.toastr.error(err?.error?.message || 'Unable to activate Autopay.')
  //     }
  //   })
  // }

  // private openMandateCheckout(response: { key: string; subscriptionId: string }): void {
  //   this.razorpayService
  //     .load()
  //     .then(() => {
  //       const options = {
  //         key: response.key,

  //         subscription_id: response.subscriptionId,

  //         name: 'AVR HRMS',

  //         description: 'Enable Auto Debit',

  //         prefill: {
  //           name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
  //           email: this.user?.email ?? '',
  //           contact: this.user?.mobile ?? ''
  //         },

  //         handler: (razorpayResponse: any) => {
  //           console.log('Mandate authentication response', razorpayResponse)

  //           // IMPORTANT:
  //           // Yahan aapka existing verification API call hona chahiye.

  //           this.toastr.success('Autopay activated successfully.')

  //           this.isProcessingPayment = false
  //         },

  //         modal: {
  //           ondismiss: () => {
  //             this.isProcessingPayment = false

  //             this.toastr.info('Autopay activation was cancelled.')
  //           }
  //         },

  //         theme: {
  //           color: '#3399cc'
  //         }
  //       }

  //       const rzp = new window.Razorpay(options)

  //       rzp.open()
  //     })
  //     .catch(error => {
  //       console.error('Failed to load Razorpay', error)

  //       this.isProcessingPayment = false

  //       this.toastr.error('Could not connect to payment gateway.')
  //     })
  // }

  activateAutopay(): void {
    const subscription = this.getCurrentSubscription()

    if (!subscription?.id) {
      this.toastr.error('Subscription not found.')
      return
    }

    this.paymentsService.activateAutopay(subscription.id).subscribe({
      next: response => {
        this.openMandateCheckout(response)
      },

      error: (err: any) => {
        this.toastr.error(err?.error?.message || 'Unable to activate Autopay.')
      }
    })
  }

  private openMandateCheckout(response: any) {
    this.razorpayService.load().then(() => {
      const options = {
        key: response.key,

        subscription_id: response.subscriptionId,

        name: 'AVR HRMS',

        description: 'Activate Autopay',

        handler: (razorpayResponse: any) => {
          console.log('Autopay authentication response', razorpayResponse)

          // Backend verification
          // this.verifyAutopay(razorpayResponse, response.internalSubscriptionId)
        },

        modal: {
          ondismiss: () => {
            this.isProcessingPayment = false
          }
        },

        theme: {
          color: '#3399cc'
        }
      }

      const rzp = new window.Razorpay(options)

      rzp.open()
    })
  }

  disableAutopay(): void {
    if (this.isProcessingPayment) return

    const subscription = this.getCurrentSubscription()
    if (!subscription?.id) {
      this.toastr.error('Active subscription not found.')
      return
    }

    this.isProcessingPayment = true

    this.paymentsService.disableAutopay(subscription.id).subscribe({
      next: res => {
        this.isProcessingPayment = false
        this.toastr.success(res.message)
        subscription.autopayEnabled = false // ya poori subscription list refetch kar lo
      },
      error: (err: any) => {
        this.isProcessingPayment = false
        this.toastr.error(err?.error?.message || 'Unable to disable Autopay.')
      }
    })
  }

  getPaymentMethodIcon(method?: string | null): string {
    switch (method) {
      case 'card':
        return 'ti-credit-card'
      case 'upi':
        return 'ti-qrcode'
      case 'netbanking':
        return 'ti-building-bank'
      case 'wallet':
        return 'ti-wallet'
      case 'emandate':
        return 'ti-refresh'
      default:
        return 'ti-currency-rupee'
    }
  }

  // formatPaymentMethod(payment: any): string {
  //   switch (payment.method) {
  //     case 'card':
  //       return payment.card && payment.card.last4
  //         ? `${payment.card.network} •••• ${payment.card.last4}`
  //         : 'Card'
  //     case 'upi':
  //       return payment.upiVpa ? `UPI (${payment.upiVpa})` : 'UPI'
  //     case 'netbanking':
  //       return payment.bankName ? `${payment.bankName} Netbanking` : 'Netbanking'
  //     case 'wallet':
  //       return payment.walletName ? `${payment.walletName} Wallet` : 'Wallet'
  //     case 'emandate':
  //       return payment.bankName ? `eMandate (${payment.bankName})` : 'eMandate'
  //     default:
  //       return '—'
  //   }
  // }

  formatPaymentMethod(payment: any): string {
    if (!payment) {
      return '—'
    }

    switch (payment.method) {
      case 'card':
        if (payment.card?.last4) {
          return `${payment.card.network || 'Card'} •••• ${payment.card.last4}`
        }

        return 'Card'

      case 'upi':
        return payment.vpa ? `UPI (${payment.vpa})` : 'UPI'

      case 'netbanking':
        return payment.bank ? `${payment.bank} Netbanking` : 'Netbanking'

      case 'wallet':
        return payment.wallet ? `${payment.wallet} Wallet` : 'Wallet'

      case 'emandate':
        return payment.bank ? `eMandate (${payment.bank})` : 'eMandate'

      default:
        return '—'
    }
  }

  formatPaymentMethodForAutopay(method?: string | null): string {
    switch (method) {
      case 'card':
        return 'Card'

      case 'upi':
        return 'UPI'

      case 'netbanking':
        return 'Net Banking'

      case 'wallet':
        return 'Wallet'

      case 'emandate':
        return 'e-Mandate'

      default:
        // return 'Payment Method'
        return '—'
    }
  }

  //pagination
  onPageChange(newPage: number): void {
    if (newPage < 1 || newPage === this.currentPage) {
      return
    }

    this.currentPage = newPage
    this.load()
  }

  onSearch(value: string): void {
    this.search = value
    this.currentPage = 1

    this.load()
  }

  onPageLimitChange() {
    this.currentPage = 1
    this.load()
  }

  onFilterChange(value: string): void {
    this.filter = value
    this.currentPage = 1

    this.load()
  }

  updatePageLastRecord(): void {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  getPaymentCardDetails(payment: any): string {
    if (payment?.method !== 'card' || !payment.card) {
      return ''
    }

    const details = []

    if (payment.card.type) {
      details.push(this.capitalize(payment.card.type))
    }

    if (payment.card.issuer) {
      details.push(payment.card.issuer)
    }

    return details.join(' · ')
  }

  capitalize(value: string): string {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
  }

  getPaymentResponse(payment: any): any {
    if (!payment?.paymentResponse) {
      return null
    }

    if (typeof payment.paymentResponse === 'object') {
      return payment.paymentResponse
    }

    try {
      return JSON.parse(payment.paymentResponse)
    } catch (error) {
      console.error('Invalid paymentResponse:', error)
      return null
    }
  }
}
